/* eslint-disable no-underscore-dangle */
import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import OSCAR from '@/assets/App_Logo.png';
import OPENID_LOGO from '@/assets/Group1.png';
import GUEST_LOGO from '@/assets/Group2.png';
import { authLogin } from '@/utils/auth';
import { meeting } from '@/models';
import LoginCardItem from '@/pages/Ready/component/LoginCardItem';
import { history } from 'umi';
import * as APIs from '@/api';
import { getQueryString } from '@/utils/common';
interface SelectLoginProps {}
export enum LOGIN_TYPE {
  Oscar = 'Oscar',
  NEOpenID = 'NEOpenId',
  GUEST = 'Guest',
}

const getMeetingId = () => {
  const search = new URLSearchParams(location.search);
  const matchArray = search.get('pwd')?.match(/meetingId.*/);
  if (matchArray?.length) {
    return matchArray[0].split('=')[1];
  }
  return '';
};
const SelectLogin: React.FC<SelectLoginProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const meetingId = getMeetingId();
    const [meetingInfo, setMeetingInfo] = useState<any>();
    const { formatMessage } = useIntl();
    const supportedAuthTypes = useMemo(() => {
      return meeting?.info?.supportedAuthTypes || meetingInfo?.supportedAuthTypes;
    }, [meeting?.info?.supportedAuthTypes, meetingInfo]);

    const allCardList = [
      {
        name: formatMessage({ id: 'oscar' }),
        content: formatMessage({ id: 'supportedAccountTypes' }),
        url: OSCAR,
        value: LOGIN_TYPE.Oscar,
      },
      {
        name: formatMessage({ id: 'usingOpenIDLogin' }),
        content: formatMessage({ id: 'supportsCorpEmailAccount' }),
        url: OPENID_LOGO,
        value: LOGIN_TYPE.NEOpenID,
      },
      {
        name: formatMessage({ id: 'guestLogin' }),
        content: formatMessage({ id: 'joinAsGuestEnabled' }),
        url: GUEST_LOGO,
        value: LOGIN_TYPE.GUEST,
      },
    ];

    const renderCardList = useMemo(() => {
      return allCardList.filter((item) => {
        return supportedAuthTypes?.includes(item.value);
      });
    }, [supportedAuthTypes]);

    const handleItemClick = async (data: LOGIN_TYPE) => {
      if (data === LOGIN_TYPE.GUEST) {
        history.push(`/meet/${meetingId}${location.search}&${LOGIN_TYPE.GUEST}=1`);
      } else {
        await authLogin(meetingId, getQueryString('pwd'), data);
      }
    };

    const getMeetingInfo = async () => {
      const resp = await APIs.getMeetingInfo(meetingId);
      setMeetingInfo(resp.data);
    };

    useEffect(() => {
      meetingId && getMeetingInfo();
    }, []);

    if (supportedAuthTypes?.length === 1) {
      handleItemClick(supportedAuthTypes[0]);
      return;
    }

    return (
      <div className={s.card}>
        <div className={s.top}>
          <div className={s.title}>{formatMessage({ id: 'LOGIN' })}</div>
          <span className={s.slectct}>{formatMessage({ id: 'membershipTypeSelection' })}</span>
        </div>
        <div className={s.content}>
          {renderCardList.map((item, index) => {
            return (
              <LoginCardItem data={item} key={index} onClick={handleItemClick}></LoginCardItem>
            );
          })}
        </div>
      </div>
    );
  })
);
export default SelectLogin;
